module.exports = __webpack_public_path__ + "img/user.b6ebd5a8.jpg";